import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { saveFile } from '../helpers/file-download';
import { BaseHttpService } from './base-http.service';
import { User } from '../models/user';

import { PaginationModel, PagedResult} from '../models';



@Injectable()
export class UsersService extends BaseHttpService<User> {

  constructor() {
    super('users');
  }

  getUsersList(model: { paginationModel: PaginationModel, searchVal: string }): Observable<PagedResult<User>> {
    return this.httpClient
      .get(this.getApiURI() + '/users/GetUserList' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&searchVal=${model.searchVal}`)
      .catch(this.handleError)
  }

  resetPassword(id: number): Observable<User> {
    return this.httpClient
      .get(this.uri + `${id}/resetpassword`)
      .catch(this.handleError)
  }

  activate(id: number): Observable<User> {
    return this.httpClient
      .get(this.uri + `${id}/activate`)
      .catch(this.handleError)
  }

  deactivate(id: number): Observable<User> {
    return this.httpClient
      .get(this.uri + `${id}/deactivate`)
      .catch(this.handleError)
  }

  downloadUsersFileTemplate() {
    const url = this.uri + "DownloadUsersFileTemplate";
    this.httpClient.get(url, { observe: "response", responseType: "blob" }).subscribe(res => {
      const fileName = res.headers.get("x-filename");
      var blob = new Blob([res.body]);
      saveFile(res.body, fileName);
      return blob;
    });
  }

  bulkInsert(users: User[]): Observable<User[]> {
    return this.httpClient
      .post(this.uri + `BulkInsert`, JSON.stringify(users))
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/users.service.ts